export default __webpack_public_path__ + "f4595b664275814ff87a90d1fa593322.svg";